/**
 * Shared pieces of the `/design-board/<slug>` routes: the production gate and
 * the search-param contract the pixel-diff harness drives.
 *
 * Every design board is gated at the route level — `beforeLoad` throws
 * `notFound()` when `NODE_ENV === "production"` (local dev is `development`,
 * preview runs `preview`), so the SAME build artifact ships everywhere and
 * only production hides the boards.
 *
 * @since 1.0.0
 */

/** True when the design board must hide (production runtime). */
export const shouldHideDesignBoard = (nodeEnv: string | undefined): boolean => nodeEnv === "production";

/** Runtime NODE_ENV, absent in browser contexts where `process` is undefined. */
export const runtimeNodeEnv = (): string | undefined =>
  typeof process === "undefined" ? undefined : process.env.NODE_ENV;

export interface DesignBoardSearch {
  /** Render exactly one frame full-bleed (for the diff harness). */
  frame?: string | undefined;
  /** Hide review chrome (the frame-picker overlay) — set by the diff harness so shots stay pixel-identical to the capture. */
  nochrome?: boolean | undefined;
}

export const validateDesignBoardSearch = (search: Record<string, unknown>): DesignBoardSearch => ({
  frame: typeof search.frame === "string" ? search.frame : undefined,
  // TanStack's search parser JSON-parses values, so `nochrome=1` arrives as the NUMBER 1
  nochrome: search.nochrome === true || search.nochrome === 1 || search.nochrome === "1" || search.nochrome === "true"
    ? true
    : undefined,
});
